/*
 * 大仓公共请求库
 * @Author: easonlchen
 * @Date: 2021-10-14 17:15:54
 * @LastEditors: easonlchen
 * @LastEditTime: 2021-11-14 22:05:56
 */

const UNKNOWN = 'unknown';
export const ErrorCodeConstant = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  RESPONSE_TIME_OUT: 504,
  NOT_SUPPORT_HTTP_VERSION: 505,
  UNKNOWN_ERROR: UNKNOWN,
};
export const ErrorMessage = {
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  500: 'Internal Server Error',
  501: 'Not Implemented',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Response Time Out',
  505: 'Not Support Http Version',
  UNKNOWN: 'Unknown Error',
};

export const HttpError = function (code, message, response = {}) {
  this.code = code;
  this.message = message;
  this.response = response;
  return {
    message: this.message,
    detail: { code: this.code, response: this.response },
  };
};
